import gql from "graphql-tag";
import xaxios from '@/xaxios';

export const meses = [
    { id: 1, text: 'enero' },
        { id: 2, text: 'febrero' }, 
        { id: 3, text: 'marzo' },
        { id: 4, text: 'abril' },
        { id: 5, text: 'mayo' },
        { id: 6, text: 'junio' },
        { id: 7, text: 'julio' },
        { id: 8, text: 'agosto' },
        { id: 9, text: 'septiembre' },
        { id: 10, text: 'octubre' },
        { id: 11, text: 'noviembre' },
        { id: 12, text: 'diciembre' },
];

export const headers = [
  { text: 'id', value: 'id', width: 40 },
  { text: 'nro', value: 'nro', width: 40 },
  { text: 'estado Consolidacion', value: 'estadoConsolidacion' },
  { text: 'registrado Sistema', value: 'registradoSistema' },
  { text: 'Numero Factura', value: 'numeroFactura', width: 40 },
  { text: 'fecha Factura', value: 'fechaFactura' }, 
  { text: 'codigoAutorizacion', value: 'codigoAutorizacion' }, 
  { text: 'nit Ci Cliente', value: 'nitCiCliente' }, 
  { text: 'complemento', value: 'complemento' }, 
  { text: 'nombre Razon Social', value: 'nombreRazonSocial' },
  { text: 'importe Total', value: 'importeTotal' }, 
  { text: 'subtotal', value: 'subtotal' },
  { text: 'descuentos', value: 'descuentos' },
  { text: 'importe Base Debito Fiscal', value: 'importeBaseDebitoFiscal' },
  { text: 'debito Fiscal', value: 'debito Fiscal' },
  { text: 'codigo Control', value: 'codigoControl' },
  { text: 'tipo Venta', value: 'tipoVenta' },
  { text: 'fecha Cuf', value: 'fechaCuf' },
  { text: 'sucursal Cuf', value: 'sucursalCuf' },
  { text: 'punto v cuf', value: 'puntoVentaCuf' },
  { text: 'numero Factura Cuf', value: 'numeroFacturaCuf' },
  { text: 'codigo Control Cuf', value: 'codigoControlCuf' },
  { text: 'doc sector', value: 'tipoDocumentoSectorCuf' },
  { text: '', value: 'actions', sortable: false, width: 120 },
];

export const headersSys = [
  { text: 'id', value: 'id', width: 40 },
  // { text: 'nro', value: 'nro', width: 40 },
  { text: 'registro SIN', value: 'registradoSIN' }, 
  { text: 'Registro portal', value: 'inportal' },
  { text: 'estado', value: 'estado' },
  { text: 'Numero Factura', value: 'numeroFactura', width: 40 },
  { text: 'fecha Factura', value: 'fechaEmision' }, 
  // { text: 'codigoAutorizacion', value: 'codigoAutorizacion' }, 
  { text: 'nit Ci Cliente', value: 'numeroDocumento' }, 
  // { text: 'complemento', value: 'complemento' }, 
  { text: 'nombre Razon Social', value: 'nombreRazonSocial' },
  { text: 'importe Total', value: 'montoTotal' }, 
  // { text: 'subtotal', value: 'subtotal' },
  { text: 'descuentos', value: 'descuentoAdicional' },
  // { text: 'importe Base Debito Fiscal', value: 'importeBaseDebitoFiscal' },
  // { text: 'debito Fiscal', value: 'debito Fiscal' },
  // { text: 'codigo Control', value: 'codigoControl' },
  // { text: 'tipo Venta', value: 'tipoVenta' },
  // { text: 'estado Consolidacion', value: 'estadoConsolidacion' },/
  { text: 'periodo', value: 'periodoFacturado' },
  // { text: 'fecha Cuf', value: 'fechaCuf' },
  { text: 'sucursal id', value: 'idSucursal' },
  { text: 'puntov id', value: 'idpuntoVenta' },
  { text: 'doc sector', value: 'codigoDocumentoSector' },
  { text: 'evento sig.', value: 'eventoID' },
  { text: 'doc origen', value: 'documentoOrigen' },
  { text: 'duplicado', value: 'duplicado' }, 
  // { text: 'numero Factura Cuf', value: 'numeroFacturaCuf' },
  // { text: 'codigo Control Cuf', value: 'codigoControlCuf' },
  { text: '', value: 'actions', sortable: false, width: 120 },
]

export const getGestiones = async (thiz) => {
    const res = await thiz.$apollo
      .query({
        query: gql`
          query {
            getGestiones {
              gestion
            }
          }
        `,
      }).then(({ data: { getGestiones } }) => getGestiones).catch((error) => error);

      const data = res.reverse();
      data.map((x) => {
        x.id = x.gestion;
        x.text = x.gestion;
      });
    
      return data;
}

export const getSucursalesBySede = async () => { 
  let url = `${process.env.VUE_APP_API_REST}/api/v1/esam/nits`;
  const res = await xaxios.get(url).then(({data})=>data).catch(e=>e);
  // window.console.log('ressss',res.data);
  if(res && res.data){
    const xxxnits = res.data;
    xxxnits.map(x=>{
      x.xtext = x.nro+' '+x.tipo_facturacion
    })
    return { xxxnits,res}
  }
  
  return {}
}

export const getIDsJEJEJE = async (ids) => {  
  let url = `${process.env.VUE_APP_API_REST}/api/pagos/recibos/buscar/ids`;
  let data = {
    ids: ids
  }
  const res = await xaxios.post(url,data).then(({data})=>data).catch(e=>e);
  // window.console.log('ressss>',res);
  if(res){
    const xxxnits = res;
    return xxxnits;
  }
  
  return {}
}

